import { render, staticRenderFns } from "./RMACenterBox.vue?vue&type=template&id=95e3fa48&"
import script from "./RMACenterBox.vue?vue&type=script&lang=js&"
export * from "./RMACenterBox.vue?vue&type=script&lang=js&"
import style0 from "./RMACenterBox.vue?vue&type=style&index=0&id=95e3fa48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports